<template>
    <div 
        :class="{'footer-buttons-1': actualView.buttonListType === 1,
            'footer-buttons-2': actualView.buttonListType === 2,
        }"
        class="footer-buttons"
    >
        <FooterButton
        v-for="(item, index) in actualView.footerButtonList"
        :key="index"
        :buttonData = item
        :buttonType = item.buttonType
        @buttonClick = buttonClick($event)
        />

        <ModalWarning
        v-if="showModal"
        :correct = "correct"
        :warningText = "warningText"
        @closeModal = "closeModal"
        />

    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapActions } from 'vuex'
import FooterButton from "@/components/game/FooterButton.vue"
import ModalWarning from "@/components/game/ModalWarning.vue"

export default {
    name: 'FooterButtons',
    components: {
        FooterButton,
        ModalWarning
    },
    data() {
        return {
            showModal: false,
            correct: false,
            warningText: ""
        }
    },
    computed: {
        ...mapGetters([
            "actualView",
            "actualProperty",
            "completed",
            "stepNumber",
            "testId"
        ])        
    },
    methods: {
        ...mapActions([
            "nextStep",
            "previousStep",
            "returnActualView",
            "setCompleted",
            "setCurrentAnswer",
            "setManyCurrentAnswer",
            "SEND_DATA_TO_API",
            "newStart",
            "increaseIndicator",
            "setTrueAnswers"
        ]),
        buttonClick(action){
            if (action === 'next') {
                if (this.completed) {
                    this.nextStep()
                }
                else {
                    if (this.actualView.type === "sections"){
                        this.clickSections()
                    }
                    else if (this.actualView.type === "info"){
                        this.clickInfo()                        
                    }
                    else if (this.actualView.type === "answers"){
                        this.clickAnswers()
                    }
                }
            }
            if (action === 'previous') {
                this.previousStep()
            }
            if (action === 'return') {
                this.returnActualView()
            }
            if (action === 'startAgain') {
                this.newStart()
            }
        },

        clickSections(){
            for (let i = 0; i < this.actualProperty.viewedSections.length; i++) {
                if (!this.actualProperty.viewedSections[i]) {
                    this.openModal("notCorrect", "Осмотр проведен не полностью", 1000, ()=>{})
                    return
                }
            }
            this.SEND_DATA_TO_API(
                {
                    "type": this.actualView.type
                }
            )

            this.setCompleted(true)
            this.increaseIndicator(1)
            this.nextStep()
        },
        clickInfo(){
            if ((this.actualView.acceptCheckbox) && (this.actualProperty.acceptCheckbox === false)) {
                this.openModal("notCorrect", "Поставьте галочку в графе “Принимаю”, чтобы продолжить", 2000, ()=>{})
                return
            }
            this.SEND_DATA_TO_API(
                {
                    "type": this.actualView.type
                }
            )

            this.setCompleted(true)
            this.increaseIndicator(1)
            this.nextStep()
        },
        clickAnswers(){
            let warningText = ""
            let answerStatus = ""

            // TODO переделать механику сообщений
            if (this.actualView.title === "План обследования") {
                const compareObject = this.compareAnswers2()
                warningText = compareObject.warningText
                answerStatus = compareObject.isRightAnswers? "correct" : "notCorrect"
            }
            else {
                answerStatus = this.compareAnswers()
                // let warningText = ""
                if (answerStatus==="correct") {
                    warningText = this.actualView.correctTextDefault
                }
                if (answerStatus==="notCorrect") {
                    warningText = this.actualView.notCorrectTextDefault
                }
                if (answerStatus==="partlyCorrect") {
                    warningText = this.actualView.partlyCorrectTextDefault

                    answerStatus = "notCorrect" //убираем желтые сообщения

                }
                
            }



            if (this.actualView.answerWarnings && this.actualView.answerWarnings.length > 0) {
                let answersTextList = ""
                for (let i = 0; i < this.actualProperty.answersList.length; i++) {
                    if (this.actualProperty.answersList[i] === true) {
                        answersTextList += i+1 +","
                    }
                }
                answersTextList = answersTextList.slice(0, -1); 

                for (let i = 0; i < this.actualView.answerWarnings.length; i++) {
                    if (this.actualView.answerWarnings[i].answersForWarning === answersTextList) {
                        warningText = this.actualView.answerWarnings[i].warningText
                    }
                    
                }
            }            

            if (answerStatus==="correct") {
                this.SEND_DATA_TO_API(
                    {
                        "type": this.actualView.type,
                        "currentAnswer": this.actualProperty.answersList,
                        "isRight": true,
                        "numberTry": this.actualProperty.numberTry
                    }
                )
                
                this.setCompleted(true)
                this.increaseIndicator(1)
                this.openModal(answerStatus, warningText, 1000, () =>{this.nextStep()})
                return
            }            
                    
            if (!this.actualView.hints) {
                this.openModal(answerStatus, warningText, 1500, ()=>{})
                return
            }

            if (this.actualProperty.numberTry === this.actualView.totalHints-1) {
                this.actualProperty.numberTry += 1
                this.SEND_DATA_TO_API(
                    {
                        "type": this.actualView.type,
                        "currentAnswer": this.actualProperty.buttonsList,
                        "isRight": false,
                        "numberTry": this.actualProperty.numberTry
                    }
                )
                
                this.setCompleted(true)
                this.openModal(answerStatus, warningText, 1500, ()=>{
                    this.openModal("partlyCorrect", "Даем подсказку!", 2000, ()=>{
                        this.setTrueAnswers()
                    })
                })
                this.increaseIndicator(1)
            }
            else if (this.actualProperty.numberTry < this.actualView.totalHints-1){
                this.SEND_DATA_TO_API(
                    {
                        "type": this.actualView.type,
                        "currentAnswer": this.actualProperty.buttonsList,
                        "isRight": false,
                        "numberTry": this.actualProperty.numberTry
                    }
                )
                this.actualProperty.numberTry += 1
                this.openModal(answerStatus, warningText, 1500, ()=>{})
            }            
        },

        compareAnswers(){
            let notAnswer = 0
            let rightAnswer = 0
            
            for (let i = 0; i < this.actualView.bodyAnswers.length; i++) {
                if (this.actualView.bodyAnswers[i].notRequired) {
                    continue
                }
                if (this.actualView.bodyAnswers[i].isRight === false) {
                    if (this.actualProperty.answersList[i] === true) {
                        return "notCorrect"
                    }
                }
                else if (this.actualView.bodyAnswers[i].isRight === true) {
                    if (this.actualProperty.answersList[i] === false) {
                        notAnswer +=1
                    }
                    else {
                        rightAnswer +=1
                    }
                }
            }
            if (rightAnswer > 0 && notAnswer > 0) {
                return "partlyCorrect"
            }
            else if (rightAnswer >0 && notAnswer === 0) {
                return "correct"
            }
            else {
                return "notCorrect"
            }
        },

        compareAnswers2(){
            let isRightAnswers = true
            let notEnoughAnswers = false
            let tooMuchAnswers = false
            let warningText = ""
            
            for (let i = 0; i < this.actualView.bodyAnswers.length; i++) {
                if (this.actualView.bodyAnswers[i].isRight === true && this.actualProperty.answersList[i] === false) {
                    isRightAnswers = false
                    notEnoughAnswers = true
                }
                if (this.actualView.bodyAnswers[i].isRight === false && this.actualProperty.answersList[i] === true) {
                    isRightAnswers = false
                    tooMuchAnswers = true
                }                
            }
            if (notEnoughAnswers) {
                warningText += "Не все исследования назначены!"
            }
            if (tooMuchAnswers) {
                warningText += "<br>Назначены лишние исследования!"
            }
            if (isRightAnswers) {
                warningText = "Исследования назначены верно!"
            }
            
            return {"isRightAnswers":isRightAnswers, "warningText": warningText}
        },        

        async openModal(correct, warningText, showTime, callback){
            this.correct = correct
            this.showModal = true
            this.warningText = warningText
            await this.sleep(showTime)
            this.showModal = false
            callback()
        },
        closeModal(){
            this.showModal = false
        },

        setTrueAnswer(){
            for (let i = 0; i < this.actualView.bodyButtons.length; i++) {
                if (this.actualView.bodyButtons[i].isRight) {
                    this.setCurrentAnswer(i)
                }
            }
        },
        setManyTrueAnswer(){
            for (let i = 0; i < this.actualView.bodyButtons.length; i++) {
                    this.setManyCurrentAnswer({"number": i, "value": this.actualView.bodyButtons[i].isRight})
            }
        },

        async setTrueCheckboxes(callback){
            for (let i = 0; i < this.actualView.bodyCheckboxes.length; i++) {
                this.actualProperty.checkboxList[i] = this.actualView.bodyCheckboxes[i].isRight
            }
            callback()
        },

        sleep(ms) {
            return new Promise((resolve) => setTimeout(resolve, ms));
        }       
        
    }
    
}
</script>

<style>
    
</style>